export default "__VITE_ASSET__CNrmId6V__"